import { Stack } from 'expo-router';
import React from 'react';

import WorkflowsPage from '../../workflows/components/WorkflowsPage';

export default function WorkflowsIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Workflows',
                }}
            />
            <WorkflowsPage />
        </>
    );
}
